import { DashboardBookingsPanel } from '@/components/dashboard/DashboardPanels';
import { DashboardHowItWorksLink } from '@/pages/dashboard/DashboardHelpPage';

export default function DashboardBookingsPage() {
  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-lg font-semibold">Bookings</h2>
        <p className="text-sm text-muted-foreground">
          Review and manage appointments from chat.{' '}
          <DashboardHowItWorksLink hash="pages" />
        </p>
      </div>
      <DashboardBookingsPanel />
    </div>
  );
}
